<template>
	<div id="app">
		<NavBar v-if="!$route.meta.Auth" />
		<NotificationContainer />
		<!-- <keep-alive>
			<router-view v-if="isRouterAlive" class="router-view" />
		</keep-alive>-->
		<keep-alive>
			<router-view
				v-if="$route.meta.keepAlive && isRouterAlive"
			></router-view>
		</keep-alive>
		<router-view
			v-if="!$route.meta.keepAlive && isRouterAlive"
		></router-view>
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import NotificationContainer from '@/components/NotificationContainer.vue'

export default {
	name: 'App',
	provide() {
		return {
			reload: this.reload,
			test: 'test'
		}
	},
	data() {
		return {
			isRouterAlive: true
		}
	},
	methods: {
		reload() {
			this.isRouterAlive = false
			this.$nextTick(() => {
				this.isRouterAlive = true
			})
		}
	},
	components: {
		NavBar,
		NotificationContainer
	}
}
</script>

<style lang="scss">
@import './src/styles/app.scss';
</style>
